<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import VueSweetalert2 from "vue-sweetalert2";
import ErrorMessage from "../../components/error-message";
/**
 * Basic-table component
 */
export default {
  components: { ErrorMessage, Layout, PageHeader },
  data() {
    return {
      title: "B2C User List",
      items: [
        {
          text: "B2c User",
          href: "/",
        },
        {
          text: "List",
          active: true,
        },
      ],
      users: [],
        errors:null,
        visible:false,
        message:"",
        status:"",
        search:"",
        search_fname:"",
        search_lname:"",
        search_gender:"",
        search_email:"",
        search_country:"",
        search_status:"",
        search_uname:"",
    };
  },
  mounted() {
    this.getUserList();
  },
    computed: {
        filteredList() {
            return this.users.filter(user => {
                return (user.first_name==null ? '' : user.first_name ).toLowerCase().includes(this.search_fname.toLowerCase())
                    || (user.last_name==null ? '' : user.last_name).toLowerCase().includes(this.search_fname.toLowerCase())
                    && (user.username==null ? '' : user.username).toLowerCase().includes(this.search_uname.toLowerCase())
                    && (user.email==null ? '' : user.email).toLowerCase().includes(this.search_email.toLowerCase())


            })
        }
    },
  methods: {
      onClose(){
          this.visible=false;
      },
      searchFilterFunc2(val) {
          this.search=val;
      },
      async userStatus(id) {
          try {
              axios
                  .post("/api/user/b2c/status/" + id, {
                      accessToken: localStorage.getItem("access_tocken"),
                  })
                  .then((response) => {
                      if (response.data.status) {
                          this.status=response.data.data.status;
                          this.$swal("Status Changed Successfully");
                          this.getUserList();
                      } else {
                          var str = response.data.message;
                          var jsonParse = JSON.parse(str);
                          this.errorCheck(jsonParse);
                      }
                  })
                  .catch((error) => {
                      console.log(error.message);
                  });
          } catch (err) {
              console.log(err);
          }
      },
      async userStatusWarning(id) {
          var _this = this;
          try {
              this.$swal({
                  title: "Are you sure?",
                  text: "You can't revert your action",
                  type: "error",
                  showCancelButton: true,
                  confirmButtonText: "Yes, Change status!",
                  cancelButtonText: "No",
                  showCloseButton: true,
                  showLoaderOnConfirm: true,
              }).then((result) => {
                  if (result.value) {
                      _this.userStatus(id);
                  } else {
                      this.$swal("Cancelled", "", "info");
                  }
              });
          } catch (err) {
              console.log(err);
          }
      },
    async getUserList() {
        this.submitted = true;
        axios
            .post("/api/user/b2c", {
                type: "b2c",
                accessToken: localStorage.getItem("access_tocken"),
            })
            .then((response) => {
                if (response.data.status) {
                    this.users=response.data.data;
                } else {
                    var str = response.data.message;
                    var jsonParse = JSON.parse(str);
                    this.errorCheck(jsonParse);
                }
            })
            .catch((error) => {
                if (error.response != undefined) {
                    this.errors = error.response.data.errors;
                }
            });
    },
    errorCheck(obj) {
        if(obj.statusCode == 403){
            this.visible=true;
            this.message="Access Permission Denied";
            this.errors = obj.message;
        }else if (obj.error) {
        this.errors = obj.message;
      } else if (obj.message == "Token has expired") {
          this.$swal.fire({
              title: 'LogOut!',
              text: 'Token Has Expired',
              icon: 'error',
              toast:'true',
              position: 'top-end',
          });
        this.$router.push({ name: "logout" });
      } else if (obj.message !== "Token has expired") {
        this.errors = obj.message;
      } else {
        this.flashMessage.show({
          time: 5000,
          status: "error",
          title: "Error",
          message: "Problem in data load",
        });
      }
    },

  },
};
</script>

<template>
  <Layout @CustomEventInputChangedAll="searchFilterFunc2" >
    <PageHeader :title="title" :items="items" />
      <ErrorMessage :visible="visible" :errors="errors" v-on:close="onClose" :message="message"/>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
<!--              <form class="app-search d-none d-lg-block">-->
<!--                  <div class="position-relative" style="width: 30%; float: right">-->
<!--                      <input type="text" v-model="search"  class="form-control" placeholder="Search..." />-->
<!--                      <span class="bx bx-search-alt"></span>-->
<!--                  </div>-->
<!--              </form>-->
            <div class="table-responsive table-responsive-sm">
              <table class="table mb-0 table-striped">
                <thead>
                  <tr>
                    <th>SL</th>
                    <th>User Id</th>
                      <th>User Name</th>
<!--                    <th>Last Name</th>-->

                      <th>Contact</th>
<!--                      <th>Phone Code</th>-->
<!--                      <th>Phone Number</th>-->
                      <th>Address</th>
                      <th>Register Date</th>
                      <th>Last Activity</th>
<!--                      <th>Country</th>-->
                      <th>Action</th>
                  </tr>
                  <tr>
                    <td> &nbsp </td>
                      <td><input type="text" class="app-search form-control" v-model="search_uname" placeholder="Search username" /></td>
                      <td><input type="text" class="app-search form-control" v-model="search_fname" placeholder="Search name" /></td>
                      <td><input type="text" class="app-search form-control" v-model="search_email" placeholder="Search email" /></td>
<!--                    <td><input type="text" class="app-search form-control" v-model="search_fname" placeholder="Search " /></td>-->
<!--                    <td><input type="text" class="app-search form-control" v-model="search_lname" placeholder="Search " /></td>-->
<!--                     <td><input type="text" class="app-search form-control" v-model="search_uname" placeholder="Search " /></td>-->
<!--                    <td> &nbsp </td>-->


                    <!-- <td><input type="text" class="app-search form-control" v-model="search_country" placeholder="Search " /></td> -->
<!--                    <td> &nbsp </td>-->
<!--                      <td> &nbsp </td>-->
<!--                      <td> &nbsp </td>-->
<!--                      <td> &nbsp </td>-->
<!--                    <td><input type="text" class="app-search form-control" v-model="search_status" placeholder="Search " /></td>-->

                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(user,index) in filteredList" v-bind:key="index">
                    <th scope="row">{{index+1}}</th>
                      <td v-if="user.username!=null">
                          <div class="row">
                              <div class="col-xs-4">{{user.username == null ? 'N/A' : user.username}}</div>
                          </div>
                          <div class="row">
                              <div class="col-xs-4"><i v-if="user.status.status=='active'" class="bx bx-check"></i> <i v-else class="bx bx-x"></i>{{user.status}}</div>
                          </div>
                          </td>
                      <td v-else >N/A</td>
                      <td v-if="user.first_name!=null">
                          <div class="row">
                              <div class="col-xs-4">{{user.first_name== null ? 'N/A' : user.first_name}} {{user.last_name== null ? 'N/A' : user.last_name}}</div>
                          </div>
                          <div class="row">
                              <div class="col-xs-4">{{user.gender==null ? 'N/A' : user.gender }}</div>
                          </div>
                      </td>
                      <td v-else >N/A</td>
                      <td v-if="user.first_name!=null">
                          <div class="row">
                              <div class="col-xs-4">{{user.email== null ? 'N/A' : user.email}}</div>
                          </div>
                          <div class="row">
                              <div class="col-xs-4">{{user.phone_code== null ? 'N/A' : user.phone_code}} {{user.phone_number == null ? 'N/A' : user.phone_number}}</div>
                          </div>
                      </td>
                      <td v-else >N/A</td>
<!--                      <td ></td>-->
<!--                      <td v-else >N/A</td>-->
<!--                      <td v-if="user.last_name!=null">{{user.last_name== null ? 'N/A' : user.last_name}}</td>-->
<!--                      <td v-else >N/A</td>-->

<!--                      <td>{{user.email}}</td>-->
                      <td v-if="user.country != null">{{user.country==null?'N/A':user.country}} {{user.country_code==null?'N/A':user.country_code}}</td>
                      <td v-else >N/A</td>
                      <td>{{user.created_at|  moment("D MMM YYYY, H:mm")}}</td>
                      <td>{{user.last_logged_in_at==null ? 'N/A' :user.last_logged_in_at |  moment("D MMM YYYY, H:mm")}}</td>
                      <td v-if="user.status != 'unregistered'">
                          <b-dropdown dropright>
                              <template v-slot:button-content>
                                  Action
                                  <i class="mdi mdi-chevron-down"></i>
                              </template>
                              <b-dropdown-item><router-link :to="{ name: 'b2c_user_show', params: {id: user.uuid } }" class="btn btn-primary btn-sm">view</router-link></b-dropdown-item>
                              <b-dropdown-item><router-link :to="{ name: 'b2c_user_update', params: {id: user.uuid } }" class="btn btn-primary btn-sm">edit</router-link></b-dropdown-item>
                              <b-dropdown-item><button v-if="user.status=='active'" class="btn btn-primary btn-sm" @click.prevent="userStatusWarning(user.uuid)">Deactivate</button><button style="width:100%" v-else class="btn btn-primary btn-sm" @click.prevent="userStatusWarning(user.uuid)">Activate</button></b-dropdown-item>
                          </b-dropdown>
                      </td>
<!--                      <td v-if="user.status != 'unregistered'"><router-link :to="{ name: 'b2c_user_show', params: {id: user.uuid } }" class="btn btn-primary btn-small">view</router-link></td>-->
<!--                      <td v-if="user.status != 'unregistered'"><router-link :to="{ name: 'b2c_user_update', params: {id: user.uuid } }" class="btn btn-primary btn-small">edit</router-link></td>-->
<!--                      <td v-if="user.status != 'unregistered'" align='center'><button v-if="user.status=='active'" class="btn btn-primary btn-small" @click.prevent="userStatusWarning(user.uuid)">Deactivate</button><button style="width:100%" v-else class="btn btn-primary btn-small" @click.prevent="userStatusWarning(user.uuid)">Activate</button></td>-->
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>
<style>

</style>
